import { useTheme } from '../themes';
import { themeRegistry } from '../themes/registry';

export type AxiSettingsThemeSectionProps = {
  /**
   * Invoked after the user picks a theme. The settings panel uses this to
   * close itself; consumers can use it for any side effect (e.g. focus
   * restore, telemetry).
   */
  onPick: () => void;
};

/**
 * Theme section inside the settings panel. Reads the active theme from
 * `useTheme()` and lists every registered theme. Clicking a row calls
 * `setTheme(slug)` and then `onPick()`.
 */
function AxiSettingsThemeSection({ onPick }: AxiSettingsThemeSectionProps) {
  const { theme: activeTheme, setTheme } = useTheme();
  return (
    <section
      className="axi-settings-section"
      aria-labelledby="axi-settings-theme-title"
    >
      <h3
        id="axi-settings-theme-title"
        className="axi-settings-section__title"
      >
        主题 / Theme
      </h3>
      <ul className="axi-settings-section__list">
        {themeRegistry.list().map((t) => {
          const isActive = t.slug === activeTheme.slug;
          return (
            <li key={t.slug}>
              <button
                type="button"
                className={
                  'axi-settings-theme-row' +
                  (isActive ? ' is-active' : '')
                }
                aria-current={isActive ? 'true' : undefined}
                onClick={() => {
                  setTheme(t.slug);
                  onPick();
                }}
              >
                <span className="axi-settings-theme-row__label">{t.label}</span>
                {isActive && (
                  <span
                    className="axi-settings-theme-row__check"
                    aria-hidden="true"
                  >
                    ✓
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default AxiSettingsThemeSection;